import { useQuery } from "@tanstack/react-query";

import { getApiKeyById, getApiKeys } from "../../services";

export const useGetApiKeys = (column, direction) => {
	return useQuery({
		queryKey: ["api_key", column, direction],
		queryFn: () => getApiKeys(column, direction),
		meta: {
			errorMessage: "There was an error getting the api keys.",
		},
	});
};

export const useGetApiKeyById = (id: string) => {
	return useQuery({
		queryKey: ["api_key", id],
		queryFn: () => getApiKeyById(id),
		meta: {
			errorMessage: "There was an error getting the api key.",
		},
	});
};
